import { Alert, AlertTitle, Link, List, ListItem, ListItemText, Stack, Typography } from "@mui/material";

import { t } from "i18next";

export const CopartnershipAlert = () => {
  return (
    <Alert severity="error" icon={false}>
      <Stack gap={2}>
        <Stack gap={1}>
          <AlertTitle sx={{ fontWeight: 700 }}>{t("copartnershipAlert.title")}</AlertTitle>
          <Stack>
            <Typography variant="body2">{t("copartnershipAlert.description")}</Typography>
            <List component="ol" dense disablePadding sx={{ listStyle: "decimal", pl: 2 }}>
              {[1, 2, 3, 4].map((item) => (
                <ListItem key={item} component="li" disableGutters disablePadding sx={{ display: "list-item" }}>
                  <ListItemText
                    primary={t(`copartnershipAlert.item${item}`, { count: item })}
                    slotProps={{ primary: { variant: "body2" } }}
                  />
                </ListItem>
              ))}
            </List>
          </Stack>
        </Stack>
        <Link
          href="https://help.scanye.pl/pl/articles/13673024-instrukcja-polaczenia-z-ksef-dla-spolek-dla-osoby-wskazanej-w-zgloszeniu-zaw-fa"
          target="_blank"
          rel="noopener noreferrer"
          color="inherit"
          sx={{ fontWeight: 600, "&:hover": { color: "error.main" } }}
        >
          {t("copartnershipAlert.linkText")}
        </Link>
      </Stack>
    </Alert>
  );
};
